export const CAMPAIGNS_PREFIX = 'campaigns/';

export const CAMPAIGNS_REQUESTED = `${CAMPAIGNS_PREFIX}CAMPAIGNS_REQUESTED`;
export const CAMPAIGNS_SUCCEEDED = `${CAMPAIGNS_PREFIX}CAMPAIGNS_SUCCEEDED`;
export const CAMPAIGNS_FAILED = `${CAMPAIGNS_PREFIX}CAMPAIGNS_FAILED`;
